@if (isLoading) {
  <app-please-wait></app-please-wait>
}

@if (summary) {
  <app-theme-page-container>
    <app-theme-page-section>
      <p-toolbar>
        <div class="p-toolbar-group-left">
          <span class="can-click" (click)="setDates('this')" title="Go to todays month"><span class="mdi mdi-calendar"></span> {{ dtAsText }} </span>
        </div>
        <div class="p-toolbar-group-right no-print">
          <app-button label="Export" icon="mdi mdi-file-excel" styleClass="p-button-outlined p-button-sm p-button-secondary mr-1" (click)="exportDialog()"></app-button>
          <app-button label="Print page" icon="mdi mdi-printer" styleClass="p-button-outlined p-button-sm p-button-secondary mr-1" (click)="printPage()"></app-button>
          <app-button label="Previous month" icon="mdi mdi-calendar-arrow-left" styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="setDates('last')"></app-button>
          <app-button label="Next month" icon="mdi mdi-calendar-arrow-right" styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="setDates('forward')" iconPos="right"> </app-button>
        </div>
      </p-toolbar>
      <main>
        <div>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Floor</th>
                <th>Room</th>
                @for (d of summary.header.days; track d) {
                  <th title="{{ d.dd }} {{ d.f }}" tooltipPosition="top">
                    {{ d.day + 1 }}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (asset of summary.assets; track asset) {
                <tr>
                  <td>{{ asset.floorTitle }}</td>
                  <td class="room" tooltipPosition="right" title="{{ asset.shapeTitle || asset.title }}">
                    <span>{{ asset.shapeTitle || asset.title }}</span>
                  </td>
                  @for (d of summary.header.days; track d) {
                    <td class="b-{{ asset.days[d.day].c }}" [class.is-hovering]="asset.days[d.day].hover" tooltipPosition="bottom" title="{{ asset.days[d.day].h }}">
                      {{ asset.days[d.day].p || '-' }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div>
          <app-rating-ae [percentage]="summary.totalPerc" [width]="240"></app-rating-ae>
        </div>
      </main>
    </app-theme-page-section>
  </app-theme-page-container>
}

@if (asset) {
  <div class="_modal">
    <div>
      <nav>
        <span (click)="asset = null" class="can-click"><i class="mdi mdi-chevron-left"></i> {{ asset.asset.title }}</span>
      </nav>
      <app-theme-page-section>
        <app-d3-occupancy [asset]="asset.asset" [df]="asset.df" [dt]="asset.dt"></app-d3-occupancy>
      </app-theme-page-section>
    </div>
  </div>
}
